import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NewWireCard from './wire-performance-components/new-wire-card';
import NewMetricNumber from '../../common/new-metric-number';

const HFlex = styled.div`
  display: flex;
`;

const Container = styled(HFlex)`
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.secondaryColor};

  & > span {
    align-self: center;
    text-align: right;
    font-size: 19px;
    width: 100px;
  }

  & > *:first-child {
    flex-grow: 2;
    text-align: left;
  }
`;

/* eslint-disable no-unused-vars */
export default function NewWirePerformance({
  id, slug, contributorName, contributorAvatarUrl, contributorSlug,
  title, publishedDate, impressions, fullViews, engagements, likesAndSaves,
  comments, ctaClicks, enquiries, campaign,
}) {
  const cardProps = {
    id,
    slug,
    contributorName,
    contributorSlug,
    contributorAvatarUrl,
    title,
    publishedDate,
    campaign,
  };

  return (
    <Container>
      <NewWireCard {...cardProps} />
      <NewMetricNumber n={impressions} />
      <NewMetricNumber n={fullViews} />
      <NewMetricNumber n={engagements} />
      <NewMetricNumber n={likesAndSaves} />
      <NewMetricNumber n={comments} />
      <NewMetricNumber n={ctaClicks} />
      <NewMetricNumber n={enquiries} />
    </Container>
  );
}
/* eslint-enable no-unused-vars */

NewWirePerformance.propTypes = {
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  contributorName: PropTypes.string.isRequired,
  contributorAvatarUrl: PropTypes.string,
  contributorSlug: PropTypes.string.isRequired,
  publishedDate: PropTypes.string.isRequired,
  impressions: PropTypes.number.isRequired,
  fullViews: PropTypes.number.isRequired,
  engagements: PropTypes.number.isRequired,
  likesAndSaves: PropTypes.number.isRequired,
  comments: PropTypes.number.isRequired,
  ctaClicks: PropTypes.number.isRequired,
  enquiries: PropTypes.number.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sentDate: PropTypes.string.isRequired,
  }),
};

NewWirePerformance.defaultProps = {
  contributorAvatarUrl: null,
  campaign: null,
};
